export const VERSION = 'dev-master#3a5448d';
